import { join } from 'light-component';
import { Input } from 'antd';
import { Box } from '../../../box';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { InputProps } from './types';

export function InputViewMode(props: InputProps): ReactElement {
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <Input type="text" readOnly={true} value={props.value} />
      </Box>
    </Box>
  );
}
